import {
  collection,
  collectionGroup,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const getAllAgentsCountForBusiness = async (bid) => {
  try {
    const AgentsCollection = collectionGroup(db, "agents");

    let q = query(
      AgentsCollection,
      where("bid", "==", bid),
      where("is_deleted", "==", false)
    );

    const AgentsSnapshot = await getDocs(q);

    const count = AgentsSnapshot.size;

    return count;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

export default getAllAgentsCountForBusiness;
